let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kJ2W9")).then(() => parcelRequire('4Ov3V'));